import {store} from './store';
import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators';
import {Iuser} from '@/types/iUser';

@Module({ namespaced: true, dynamic: true, store, name: 'storeUser'})
export default class User extends VuexModule {
    user:Iuser={
        userid:'',
        email:'',
        lastName:'',
        firstName:'',
        isEmailChecked:false,
        isAuthenticated:false,
        csrf_token:''
    };

    MyImgProfileString64:string='';

    @Mutation
    SET_USER(puser:Iuser){
        this.user=puser;
    }
    @Action
    set_user(puser:Iuser){
        this.context.commit('SET_USER',puser);
    }


    @Mutation
    SET_CSRF_TOKEN(ptoken:string){
        this.user.csrf_token=ptoken;
    }
    @Action
    set_csrf_token(ptoken:string){
        this.context.commit('SET_CSRF_TOKEN',ptoken);
    }

    @Mutation
    SET_MYIMGPROFILESTRING64R(pimgstring:string){
        this.MyImgProfileString64=pimgstring;
    }
    @Action
    set_myimgprofilestring64r(pimgstring:string){
        this.context.commit('SET_MYIMGPROFILESTRING64R',pimgstring);
    }

}
